const isInAppUrl = (url, currentHref, currentOrigin)=>{
    try {
        return new URL(url, currentHref).origin === currentOrigin;
    } catch (unused) {
        return false;
    }
};
export const makeNativeChangeLocation = (param)=>{
    let { navigate, showSplashScreen, getLocation } = param;
    return (url)=>{
        const { href, origin } = getLocation();
        if (isInAppUrl(url, href, origin)) {
            void showSplashScreen().then(()=>navigate(url));
        } else {
            navigate(url);
        }
    };
};
export const makeNativeLocationReload = (param)=>{
    let { reload, showSplashScreen } = param;
    return ()=>{
        void showSplashScreen();
        reload();
    };
};
